"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleListCategory = void 0;
var ModuleListCategory;
(function (ModuleListCategory) {
    ModuleListCategory["Search"] = "ModuleListSearch";
})(ModuleListCategory || (exports.ModuleListCategory = ModuleListCategory = {}));
